import React from 'react';
import {
  Box,
  Grid,
  GridColumn,
  GridContainer,
  GridRow,
  SparkContentLoader,
} from '@sparknz/spark-pattern-library';

export function OptionsLoader() {
  return (
    <SparkContentLoader height="256px" width="100%" title="Loading options...">
      <rect x="0" y="0" rx="4" ry="4" width="360" height="32" />
      <rect x="0" y="48" rx="4" ry="4" width="280" height="32" />
      <rect x="0" y="96" rx="4" ry="4" width="300" height="60" />
      <rect x="0" y="172" rx="4" ry="4" width="300" height="60" />
    </SparkContentLoader>
  );
}

export function ConfiguratorLoader() {
  return (
    <SparkContentLoader
      height="680px"
      width="100%"
      title="Loading Configurator..."
    >
      <rect x="0" y="0" rx="12" ry="12" width="215" height="58" />
      <rect x="0" y="98" rx="6" ry="6" width="455" height="20" />
      <rect x="0" y="124" rx="6" ry="6" width="455" height="20" />
      <rect x="0" y="150" rx="6" ry="6" width="455" height="20" />
      <rect x="0" y="176" rx="6" ry="6" width="455" height="20" />
      <rect x="0" y="202" rx="6" ry="6" width="289" height="20" />
      <rect x="0" y="262" rx="16" ry="16" width="32" height="32" />
      <rect x="65" y="262" rx="16" ry="16" width="32" height="32" />
      <rect x="0" y="334" rx="12" ry="12" width="215" height="58" />
      <rect x="0" y="432" rx="12" ry="12" width="215" height="48" />
    </SparkContentLoader>
  );
}

export const ImageGalleryLoader = () => {
  return (
    <SparkContentLoader height="680px" width="100%" title="Loading images...">
      <rect x="0" y="0" rx="12" ry="12" width="455" height="455" />
      <rect x="44" y="479" rx="12" ry="12" width="80" height="80" />
      <rect x="140" y="479" rx="12" ry="12" width="80" height="80" />
      <rect x="236" y="479" rx="12" ry="12" width="80" height="80" />
      <rect x="332" y="479" rx="12" ry="12" width="80" height="80" />
    </SparkContentLoader>
  );
};

export const ProductConfiguratorLoader = () => {
  return (
    <Box
      pt={['s5', 's7', 's9']}
      mb={['s5', 's7', 's9']}
      ml={['s3', 's4', 's10']}
    >
      <GridContainer variant="full-width">
        <Grid>
          <GridRow>
            <GridColumn lil={2} slim={3} big={6}>
              <ConfiguratorLoader />
            </GridColumn>
            <GridColumn lil={2} slim={3} big={5} bigOffset={1}>
              <ImageGalleryLoader />
            </GridColumn>
          </GridRow>
        </Grid>
      </GridContainer>
    </Box>
  );
};
